var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpathy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1674 12.5C38.4591 12.5 25.7924 24.7917 25.0008 40.25L17.0008 50.7917C16.0008 52.0833 17.0008 54.1667 18.7508 54.1667H25.0008V66.6667C25.0008 71.2917 28.7091 75 33.3341 75H37.5008V87.5H66.6674V67.9583C76.5424 63.2917 83.3341 53.3333 83.3341 41.6667C83.3341 25.5833 70.3341 12.5 54.1674 12.5ZM70.8341 36.7917C70.8341 43.2083 65.1674 48.3333 56.5841 56.125L54.1674 58.3333L51.7508 56.125C43.1674 48.3333 37.5008 43.2083 37.5008 36.7917C37.5008 31.7917 41.5008 27.6667 46.5008 27.625H46.6674C49.5424 27.625 52.2924 28.9167 54.1674 31.0833C56.0424 28.9167 58.7924 27.625 61.6674 27.625C66.6674 27.5833 70.8341 31.625 70.8341 36.625V36.7917Z",
    fill: "#31D054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpathy);
export default __webpack_public_path__ + "static/media/empathy.b92da5cabad874ac695a7c143005bd14.svg";
export { ForwardRef as ReactComponent };